import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import useChannelStore from '@/stores/ChannelStore';
import Heading from '../Heading';
import { Flex, useDisclosure } from '@chakra-ui/react';
import ChatWindow from '../giveaways/ChatWindow';
import GiveawayPanel from '../giveaways/GiveawayPanel';
import GiveawayModal from '../giveaways/GiveawayModal';
import { Helmet } from 'react-helmet';
import useGiveawayStore from '@/stores/GiveawayStore';
import useIntlMemo from '@/hooks/useIntlMemo';
import { GiveawayType } from '@/types/client';
import { useShallow } from 'zustand/react/shallow';
export default function Giveaways() {
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var _useGiveawayStore = useGiveawayStore(useShallow(function(state) {
        return {
            type: state.type,
            phrase: state.phrase,
            activityTimeout: state.activityTimeout,
            minRandomNumber: state.minRandomNumber,
            maxRandomNumber: state.maxRandomNumber
        };
    })), type = _useGiveawayStore.type, phrase = _useGiveawayStore.phrase, activityTimeout = _useGiveawayStore.activityTimeout, minRandomNumber = _useGiveawayStore.minRandomNumber, maxRandomNumber = _useGiveawayStore.maxRandomNumber;
    var giveawayModal = useDisclosure();
    var giveawayTitle = useIntlMemo(function(intl) {
        switch(type){
            case GiveawayType.ACTIVE_USER:
                return intl.formatMessage({
                    id: "hD43nJ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Giveaway"
                        }
                    ]
                });
            case GiveawayType.KEYWORD:
                return intl.formatMessage({
                    id: "0gvdUD",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Keyword Giveaway"
                        }
                    ]
                });
            case GiveawayType.RANDOM_NUMBER:
                return intl.formatMessage({
                    id: "FXn2yf",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Random Number"
                        }
                    ]
                });
        }
    }, [
        type
    ]);
    var giveawayDescription = useIntlMemo(function(intl) {
        switch(type){
            case GiveawayType.ACTIVE_USER:
                return intl.formatMessage({
                    id: "cQ+pJO",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Send a message within the last "
                        },
                        {
                            type: 1,
                            value: "activityTimeout"
                        },
                        {
                            type: 0,
                            value: " minutes to enter the giveaway."
                        }
                    ]
                }, {
                    activityTimeout: activityTimeout
                });
            case GiveawayType.KEYWORD:
                if (phrase == null || phrase.length === 0) {
                    return intl.formatMessage({
                        id: "Dsvmcf",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Send a message containing a keyword in chat to enter the giveaway."
                            }
                        ]
                    });
                } else {
                    return intl.formatMessage({
                        id: "D1N6Fv",
                        defaultMessage: [
                            {
                                type: 0,
                                value: 'Send a message containing "'
                            },
                            {
                                type: 1,
                                value: "phrase"
                            },
                            {
                                type: 0,
                                value: '" in chat to enter the giveaway.'
                            }
                        ]
                    }, {
                        phrase: phrase
                    });
                }
            case GiveawayType.RANDOM_NUMBER:
                return intl.formatMessage({
                    id: "BK3VWn",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Giveaway for users who guess a random number from "
                        },
                        {
                            type: 1,
                            value: "minRandomNumber"
                        },
                        {
                            type: 0,
                            value: " to "
                        },
                        {
                            type: 1,
                            value: "maxRandomNumber"
                        },
                        {
                            type: 0,
                            value: "."
                        }
                    ]
                }, {
                    maxRandomNumber: maxRandomNumber,
                    minRandomNumber: minRandomNumber
                });
        }
    }, [
        type,
        phrase,
        maxRandomNumber
    ]);
    if (channel == null) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        containerProps: {
            maxHeight: '100vh'
        },
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: giveawayTitle
            }),
            /*#__PURE__*/ _jsx(Heading, {
                subHeading: giveawayDescription,
                children: giveawayTitle
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                flex: 1,
                gap: 6,
                maxHeight: "1000px",
                children: [
                    /*#__PURE__*/ _jsx(GiveawayPanel, {
                        flex: 1,
                        onOpen: giveawayModal.onOpen,
                        isGiveawayModalOpen: giveawayModal.isOpen
                    }),
                    /*#__PURE__*/ _jsx(ChatWindow, {
                        flex: 1,
                        channel: channel,
                        display: {
                            base: 'none',
                            xl: 'grid'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(GiveawayModal, {
                isOpen: giveawayModal.isOpen,
                onClose: giveawayModal.onClose,
                onComplete: giveawayModal.onClose
            })
        ]
    });
}
